import createIcon from '../../createIcon';

/**
 * @component @name SaveAlt
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgMTJWMTlINVYxMkgzVjE5QzMgMjAuMSAzLjkgMjEgNSAyMUgxOUMyMC4xIDIxIDIxIDIwLjEgMjEgMTlWMTJIMTlaTTEzIDEyLjY3TDE1LjU5IDEwLjA5TDE3IDExLjVMMTIgMTYuNUw3IDExLjVMOC40MSAxMC4wOUwxMSAxMi42N1YzSDEzVjEyLjY3WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SaveAlt = createIcon('SaveAlt', [
  [
    'path',
    {
      d: 'M19 12V19H5V12H3V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V12H19ZM13 12.67L15.59 10.09L17 11.5L12 16.5L7 11.5L8.41 10.09L11 12.67V3H13V12.67Z',
      key: '147lqg',
    },
  ],
]);

export default SaveAlt;
